export { default as MastheadHome } from './Home'
export { default as MastheadCaseStudy } from './CaseStudy'
export { default as MastheadStaffMember } from './StaffMember'
export { default as MastheadBusinessEnquiries } from './BusinessEnquiries'
export { default as MastheadContact } from './Contact'
export { default } from './Default'
